export default "__VITE_ASSET__DNdtTRsp__"